/** Station and assembly group quantities must be positive, and `null` stands for a quantity of 1 */
export const positiveQuantityOrNull = (quantity: number | null | undefined): number | null =>
  quantity != null && quantity > 0 ? quantity : null;
